import { brands } from '../data/content';

const LogoCard = ({ b }) => (
  <div
    data-testid={`brand-logo-${b.name.toLowerCase().replace(/[^a-z0-9]+/g, '-')}`}
    title={b.name}
    className="mx-3 flex h-24 w-48 shrink-0 flex-col items-center justify-center gap-1.5 rounded-xl border border-ink/10 bg-white px-5 shadow-[0_12px_34px_-20px_rgba(15,43,29,0.3)] sm:w-52"
  >
    <img
      src={b.logo}
      alt={`${b.name} logo`}
      loading="lazy"
      className="max-h-12 w-auto max-w-full object-contain sm:max-h-14"
    />
    <span className="max-w-full truncate font-mono text-[9px] uppercase tracking-[0.16em] text-ink">
      {b.name}
    </span>
  </div>
);

export const BrandMarquee = () => {
  const row = [...brands, ...brands, ...brands];
  return (
    <section
      data-testid="trusted-brands"
      aria-label="Brands that trust TheBigHub"
      className="marquee-hover-pause relative z-10 -mb-10 overflow-hidden bg-white pb-20 pt-28 sm:pt-32"
      style={{
        WebkitMaskImage: 'linear-gradient(to bottom, black 84%, transparent 100%)',
        maskImage: 'linear-gradient(to bottom, black 84%, transparent 100%)',
      }}
    >
      <div className="mx-auto mb-8 flex max-w-7xl items-center justify-center gap-4 px-5">
        <span className="gold-rule" aria-hidden="true" />
        <p className="eyebrow text-center" data-testid="trusted-brands-title">
          Trusted by Brands That Think Bigger
        </p>
        <span className="gold-rule" aria-hidden="true" />
      </div>
      <div className="flex w-max animate-marquee will-change-transform">
        <div className="flex">
          {row.map((b, i) => (
            <LogoCard key={`a-${b.name}-${i}`} b={b} />
          ))}
        </div>
        <div className="flex" aria-hidden="true">
          {row.map((b, i) => (
            <LogoCard key={`b-${b.name}-${i}`} b={b} />
          ))}
        </div>
      </div>
    </section>
  );
};
